// src/components/editor/ConfirmModal.jsx
//
// Lightweight custom confirmation dialog, styled to match the app's other
// modals (e.g. the checkpoint-restore modal in BookCoverDesigner) rather than
// the browser's native window.confirm. Reusable for any confirm/cancel flow.
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const ConfirmModal = ({
  open,
  title = 'Are you sure?',
  message,
  highlight,          // optional emphasized line (e.g. the item name)
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  destructive = false, // red confirm button for delete-style actions
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  const confirmBg = destructive ? '#dc2626' : '#7c3aed';
  const confirmHover = destructive ? '#b91c1c' : '#6d28d9';

  return (
    <Box
      onClick={onCancel}
      sx={{
        position: 'fixed', inset: 0, zIndex: 13000,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          background: '#fff', borderRadius: '12px',
          padding: '28px 32px 24px', maxWidth: 420, width: '90%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.25)', textAlign: 'center',
        }}
      >
        <Typography sx={{ fontSize: 17, fontWeight: 700, color: '#1f2937', mb: 1.5 }}>
          {title}
        </Typography>
        {highlight && (
          <Typography sx={{ fontSize: 15, fontWeight: 600, color: '#5b21b6', mb: 1 }}>
            “{highlight}”
          </Typography>
        )}
        {message && (
          <Typography sx={{ fontSize: 13, color: '#6b7280', mb: 2.5, lineHeight: 1.5 }}>
            {message}
          </Typography>
        )}
        <Box sx={{ display: 'flex', gap: 1.25, justifyContent: 'center' }}>
          <Button
            onClick={onCancel}
            sx={{
              px: 2.5, py: 1, borderRadius: '6px', textTransform: 'none',
              border: '1px solid #d1d5db', background: '#fff', color: '#374151',
              fontWeight: 600, fontSize: 13,
              '&:hover': { background: '#f3f4f6', border: '1px solid #d1d5db' },
            }}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={onConfirm}
            sx={{
              px: 2.5, py: 1, borderRadius: '6px', textTransform: 'none',
              background: confirmBg, color: '#fff', fontWeight: 600, fontSize: 13,
              '&:hover': { background: confirmHover },
            }}
          >
            {confirmLabel}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ConfirmModal;
